<template lang="pug">
  section.hero.is-light.is-fullheight: .hero-body
    .container: .columns: .column.is-4.is-offset-4(@keyup.enter="onLogin")
      transition(name="slide" appear): div.modal.is-active
        b-modal.p-20(:can-cancel="false" active has-modal-card)
          .modal-card-head.is-block.has-text-centered
            strong Медпред CRM
              span.has-text-grey  | Техподдержка
          .modal-card-body
            b-field.control.is-expanded(:type="errors.email ? 'is-danger' : ''" :message="errors.email")
              b-input(v-model="authEmail" :disabled="inProgress" type="email" icon="email" placeholder="E-mail" size="is-medium")

            b-field.control.is-expanded(:type="errors.password ? 'is-danger' : 'is-expanded'" :message="errors.password")
              b-input(v-model="authPassword" :disabled="inProgress" type="password" icon="key" placeholder="Пароль" size="is-medium")

          .modal-card-foot.is-block.has-text-centered
            button.button.is-primary(@click="onLogin" :class="{'is-loading':inProgress}") Войти

    //- .hero-foot: .container.has-text-centered Медпред CRM (C) 2015
</template>

<script>
import api from '@/api';
import { mapMutations } from 'vuex';
import { ToastProgrammatic as Toast } from 'buefy';

export default {
  name: 'auth',

  data: () => ({
    auth: false,
    inProgress: false,
    authEmail: '',
    authPassword: '',
    errors: {
      email: null,
      password: null,
    },
  }),

  methods: {
    ...mapMutations(['setUser']),

    onLogin() {
      this.inProgress = true;
      this.errors = {};
      api
        .login(this.authEmail, this.authPassword)
        .then(() => {
          api.user({ include: 'platform,role.permissions' }).then(({ data }) => {
            Toast.open({
              message: 'Вы авторизованы!',
              type: 'is-success',
            });
            this.inProgress = false;
            this.setUser(data);
          });
        })
        .catch(({ validation }) => {
          this.inProgress = false;
          if (validation) {
            this.errors.email = validation.email ? validation.email[0] : null;
            this.errors.password = validation.password ? validation.password[0] : null;
          }
        });
    },
  },
};
</script>
